import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {ApolloClient, HttpLink, InMemoryCache, from, ApolloProvider} from "@apollo/client";
import {onError} from "@apollo/client/link/error";
import { setContext } from '@apollo/client/link/context';

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
        );
    if (networkError) console.log(`[Network error]: ${networkError}`);
});

const authLink = setContext((_, { headers }) => {
    const rawUser = localStorage.getItem("auth")

    return {
        headers: {
            ...headers,
            authorization: rawUser ? `${JSON.parse(rawUser).token}` : "",
        }

    }

});

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL })

export const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([errorLink, authLink.concat(httpLink)]),
    defaultOptions: {
        watchQuery: {
            errorPolicy: "all",
            fetchPolicy: 'no-cache',
            notifyOnNetworkStatusChange: true,
        },
        query: {
            errorPolicy: "all",
            fetchPolicy: 'no-cache',
            notifyOnNetworkStatusChange: true,
        },
        mutate: {
            errorPolicy: "all",
            fetchPolicy: 'no-cache',
        }
    },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <ApolloProvider client={client}>
          <App />
      </ApolloProvider>
  </React.StrictMode>
);
